/* OMRUs mega menu + mobile drawer. No dependencies. */
(function () {
  'use strict';
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var items = [];

  function MegaItem(li) {
    var self = this;
    this.li = li;
    this.btn = li.querySelector('[data-omr-toggle]');
    this.panel = this.btn && document.getElementById(this.btn.getAttribute('aria-controls'));
    if (!this.panel) return;
    this.timer = null;

    this.btn.addEventListener('click', function () { self.isOpen() ? self.close() : self.open(); });

    li.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !finePointer.matches) return;
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.open(); }, 90);
    });
    li.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.close(); }, 220);
    });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen()) {
        e.stopPropagation();
        self.close();
        self.btn.focus();
      }
    });
    li.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !li.contains(e.relatedTarget)) self.close();
    });

    var closeBtn = this.panel.querySelector('[data-omr-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); self.btn.focus(); });

    initCarousel(this.panel.querySelector('[data-omr-carousel]'));
    items.push(this);
  }
  MegaItem.prototype.isOpen = function () { return !this.panel.hidden; };
  MegaItem.prototype.open = function () {
    var self = this;
    items.forEach(function (it) { if (it !== self) it.close(); });
    if (this.isOpen()) return;
    this.panel.hidden = false;
    this.btn.setAttribute('aria-expanded', 'true');
    this.li.classList.add('is-open');
  };
  MegaItem.prototype.close = function () {
    clearTimeout(this.timer);
    if (!this.isOpen()) return;
    this.panel.hidden = true;
    this.btn.setAttribute('aria-expanded', 'false');
    this.li.classList.remove('is-open');
  };

  function initCarousel(root) {
    if (!root) return;
    var track = root.querySelector('[data-omr-track]');
    var prev = root.querySelector('[data-omr-prev]');
    var next = root.querySelector('[data-omr-next]');
    if (!track || !prev || !next) return;
    var ticking = false;
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      var none = track.scrollWidth <= track.clientWidth + 2;
      prev.hidden = none; next.hidden = none;
    }
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    // the panel is hidden on load, so measure when it opens
    window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    new MutationObserver(update).observe(root.closest('.omr-mm__panel'), { attributes: true, attributeFilter: ['hidden'] });
  }

  // close desktop panels on outside click
  document.addEventListener('click', function (e) {
    items.forEach(function (it) { if (!it.li.contains(e.target)) it.close(); });
  });

  // Focus the search field as soon as the theme's search popup opens
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-open-search-popup]')) return;
    var tries = 0;
    (function attempt() {
      var list = document.querySelectorAll('input[name="q"]:not(#omr-dr-q), input[type="search"]:not(#omr-dr-q)');
      for (var i = 0; i < list.length; i++) {
        if (list[i].getBoundingClientRect().width > 0) { list[i].focus(); if (document.activeElement === list[i]) return; }
      }
      if (++tries < 12) setTimeout(attempt, 100);
    })();
  }, true);

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('.omr-dr');
    if (!drawer) return;
    var tabs = [].slice.call(drawer.querySelectorAll('[data-omr-tab]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-expanded', on ? 'true' : 'false');
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        var panels = drawer.querySelector('.omr-dr__panels');
        if (panels) panels.scrollTop = 0;
      });
    });

    // Make Minimog's hamburger (a <div>) operable by keyboard + screen readers
    var burger = document.querySelector('.m-header__mobile .m-hamburger-box') || document.querySelector('.m-hamburger-box');
    if (!burger) return;
    burger.setAttribute('role', 'button');
    burger.setAttribute('tabindex', '0');
    burger.setAttribute('aria-controls', 'm-menu-drawer');
    function sync() {
      var open = drawer.classList.contains('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      return open;
    }
    sync();
    burger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); burger.click(); }
    });
    var wasOpen = false;
    new MutationObserver(function () {
      var open = sync();
      if (open && !wasOpen) {
        var first = drawer.querySelector('[data-omr-tab][aria-expanded="true"]') || drawer.querySelector('.omr-dr__tab');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 260);
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) { burger.click(); burger.focus(); }
    });
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-omr-mega]'), function (li) { new MegaItem(li); });
    initDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // theme editor: re-init when header section reloads
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-omr-mega], .omr-dr')) { items = []; init(); }
  });
})();
